// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3-MqS","modalForm":"UpgradeEpcsModal_modalForm__30Qsk","modalFooter":"UpgradeEpcsModal_modalFooter__pg0sk"};